import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the unit tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['units/trackedUnitsModule/get']
}

/**
 * Returns units that are being tracked.
 *
 * @return Array
 */
export const trackedUnits = () => {
  return store.getters['units/trackedUnitsModule/trackedUnits']
}

/**
 * Returns a filtered array of units being tracked.
 *
 * @param filter String
 *
 * @return Array
 */
export const trackedUnitsFiltered = (filter) => {
  const units = store.getters['units/trackedUnitsModule/trackedUnits']
  const unitIds = Object.keys(units)
  filter = filter.trim().toLowerCase()
  let filteredUnits = []

  unitIds.forEach(unitId => {
    const unit = units[unitId]

    const imei = unit.imei !== null ? unit.imei.toLowerCase() : ''
    const serial_no = unit.serial_no !== null ? unit.serial_no.toLowerCase() : ''
    const client_name = unit.client !== null ? unit.client.name.toLowerCase() : ''

    if (imei.indexOf(filter) !== -1 ||
      serial_no.indexOf(filter) !== -1 ||
      client_name.indexOf(filter) !== -1) {
      filteredUnits.push(unit)
    }
  })

  return filteredUnits
}

/**
 * Returns the first tracked unit or null if none being tracked.
 *
 * @return Object|null
 */
export const trackedUnit = () => {
  let trackedUnits = store.getters['units/trackedUnitsModule/trackedUnits']
  let unitIds = Object.keys(trackedUnits)
  if (unitIds.length > 0) {
    if (trackedUnits.hasOwnProperty(unitIds[0])) {
      return trackedUnits[unitIds[0]]
    }
  }

  return null
}

/**
 * Returns the requested tracked unit or null if it is not being tracked.
 *
 * @param id Integer
 *
 * @return Object|null
 */
export const trackedUnitById = (id) => {
  let trackedUnits = store.getters['units/trackedUnitsModule/trackedUnits']
  if (trackedUnits.hasOwnProperty(id)) {
    return trackedUnits[id]
  } else {
    return null
  }
}

/**
 * Returns the number of units being tracked.
 *
 * @return Integer
 */
export const trackedUnitCount = () => {
  return store.getters['units/trackedUnitsModule/trackedUnitCount']
}

/**
 * Returns true if the specified unit is being tracked.
 *
 * @param id Integer
 *
 * @return Boolean
 */
export const isTracked = (id) => {
  return store.getters['units/trackedUnitsModule/trackedUnits'].hasOwnProperty(id)
}

/**
 * Add a map or array of object units that must be tracked.
 *
 * @param units Array|Map
 */
export const addTrackedUnits = (units) => {
  store.commit('units/trackedUnitsModule/addTrackedUnits', units)
}

/**
 * Removes an array of units that should no longer be tracked.
 * The array must consist of the id's of the units that no longer
 * requires tracking.
 *
 * @param units Array
 */
export const removeTrackedUnits = (units) => {
  store.commit('units/trackedUnitsModule/removeTrackedUnits', units)
}

/**
 * Removes all units from being tracked.
 */
export const clearTrackedUnits = () => {
  store.commit('units/trackedUnitsModule/clearTrackedUnits')
}

/**
 * Clears all units from being tracked.
 */
export const purge = () => {
  store.commit('units/trackedUnitsModule/purge')
}

/**
 * Sets the telemetry data for the specified unit.
 *
 * @param unitId int
 * @param telemetry Object
 */
export const setTelemetry = (unitId, telemetry) => {
  store.commit('units/trackedUnitsModule/setTelemetry', {
    unitId, telemetry
  })
}

/**
 * Sets the analog input configuration for the specified unit.
 *
 * @param unitId int
 * @param analogInputConfig Object
 */
export const setAnalogInputCfg = (unitId, analogInputConfig) => {
  store.commit('units/trackedUnitsModule/setAnalogInputCfg', {
    unitId, analogInputConfig
  })
}

/**
 * Returns the tracked unit's telemetry or null if the unit is not found or
 * it doesn't have telemetry data.
 *
 * @param unitId Integer
 *
 * @return Object|null
 */
export const getTelemetry = (unitId) => {
  let trackedUnits = store.getters['units/trackedUnitsModule/trackedUnits']
  if (trackedUnits.hasOwnProperty(unitId)) {
    let trackedUnit = trackedUnits[unitId]
    if (trackedUnit !== null && trackedUnit.hasOwnProperty('telemetry')) {
      return trackedUnit['telemetry']
    }
  }

  return null
}

/**
 * Returns the tracked unit's analog input configuration or null if the unit is not found or
 * it doesn't have analog input configuration data.
 *
 * @param unitId Integer
 *
 * @return Object|null
 */
export const getAnalogInputCfg = (unitId) => {
  let trackedUnits = store.getters['units/trackedUnitsModule/trackedUnits']
  if (trackedUnits.hasOwnProperty(unitId)) {
    let trackedUnit = trackedUnits[unitId]
    if (trackedUnit !== null && trackedUnit.hasOwnProperty('an_inputs')) {
      return trackedUnit['an_inputs']
    }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/store/units/trackedUnits.helpers.js